import React, { useState } from "react";
import { Link, AddToolTip } from "../../components";
import { Image } from "react-bootstrap";
import Employeepic from "../../assets/employeePhoto.jpeg";
import { MANAGE_TRANSACTION_ROUTES } from "../../utils";
const date = new Date();
const TransactionHistoryDetailTile = (props) => {
  const { data } = props;

  const [viewMoreToggle, setToggle] = useState(false);
  const viewMore = () => {
    setToggle(() => !viewMoreToggle);
  };
  return (
    <div className="main-history-detail-tile">
      <div className="history-detail-view-more-tile">
        <div
          className="history-detail-tile"
          style={{
            padding: `${!viewMoreToggle ? "0 2rem 0 0" : "0 2rem 1rem 0"}`,
          }}
        >
          <div className="d-flex">
            <Image
              src={Employeepic}
              alt="empic"
              roundedCircle
              className="image-transaction-history-detail"
              style={{ marginRight: "0.3rem" }}
            />

            <div>
              {data.name.length > 30 ? (
                <AddToolTip name={data.name}>
                  <div className="history-detail-main-Text">
                    {(data.name || "").slice(0, 30)}...
                  </div>
                </AddToolTip>
              ) : (
                <div className="history-detail-main-Text">{data.name}</div>
              )}
              {data.ssn?.length > 30 ? (
                <AddToolTip name={data.ssn}>
                  <div className="history-detail-normal-Text">
                    {(data.ssn || "").slice(0, 30)}...
                  </div>
                </AddToolTip>
              ) : (
                <div className="history-detail-normal-Text">{data.ssn}</div>
              )}
            </div>
          </div>
          <div>
            <div className="history-detail-main-Text">{data.planName}</div>
            <div className="history-detail-normal-Text">
              {data.rkPlanNumber}
            </div>
          </div>

          <div>
            <div className="history-detail-main-Text">
              {data.transactionType}
            </div>

            <div className="history-detail-normal-Text">
              {data.transactionSubType}
            </div>
          </div>

          <div>
            <div className="history-detail-main-Text">{data.amount}</div>
          </div>

          {!viewMoreToggle && (
            <div className="seperator-transaction-history-detail"></div>
          )}
          <div className="more-history-details-button" onClick={viewMore}>
            {!viewMoreToggle ? "View More" : "Hide More"}
          </div>
        </div>
        {viewMoreToggle && (
          <div className="view-more-bottom">
            <div className="d-flex">
              <Image
                src={Employeepic}
                alt="empic"
                roundedCircle
                className="image-transaction-history-detail"
                style={{ marginRight: "0.3rem" }}
              />

              <div>
                {"Global Corp Pvt".length > 30 ? (
                  <AddToolTip name={"Global Corp Pvt"}>
                    <div className="history-detail-normal-Text">
                      {("Global Corp Pvt" || "").slice(0, 30)}...
                    </div>
                  </AddToolTip>
                ) : (
                  <div className="history-detail-normal-Text">
                    {"Global Corp Pvt"}
                  </div>
                )}
              </div>
            </div>
            <div>
              <div className="history-detail-normal-Text">Requested by</div>
              <div className="history-detail-main-Text">{"David Mitch"}</div>
            </div>
            <div>
              <div className="history-detail-normal-Text">{"Admin"}</div>
            </div>

            <div>
              <div className="history-detail-normal-Text">{"2/3/2021"}</div>
            </div>
            <div>
              <div className="history-detail-normal-Text">Approved by</div>
              <div className="history-detail-main-Text">{"Jim Carry"}</div>
            </div>
            <div>
              <div className="history-detail-normal-Text">{"TPA"}</div>
            </div>
            <div>
              <div className="history-detail-normal-Text">{"2/3/2021"}</div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default TransactionHistoryDetailTile;
